export const REDUCER_NAME = 'shiprocketSlice';

export interface iShiprocketDTO {
  email?: string;
  phoneNumber?: string;
  password?: string;
  pickupLocation?: string;
  companyName?: string;
  channelId?: string;
  companyId?: string;
  vendorId?: string;
  shipment_id?:string;
}

export interface iShiprocketState {
    isLoading: boolean;
    shiprocketUser: iShiprocketDTO | null;
    errorMessage: string | null;
}